import { useShallow } from 'zustand/shallow'

import { Dialog, DialogContent } from '@/components/atoms/Dialog'
import DealerForm from '@/components/molecules/DealerForm'
import { useScopedI18n } from '@/locales/client'
import type { DialogTypes } from '@/stores/DialogsStore'
import useDialogsStore from '@/stores/DialogsStore'

const DIALOG_ID: DialogTypes = 'sendToDealer'

function SendToDealerDialog() {
  const t = useScopedI18n('dialogs.sendToDealer')
  const { open } = useDialogsStore(useShallow(state => state.dialogs.sendToDealer))
  const toggle = useDialogsStore(useShallow(state => state.toggle))

  return (
    <Dialog open={open} onOpenChange={() => toggle(DIALOG_ID)}>
      <DialogContent className="flex flex-col items-center justify-center gap-8 p-12 text-center transition-all duration-300 ease-in-out">
        <DealerForm
          titleText={t('formTitle')}
          buttonText={t('formButton')}
        />
      </DialogContent>
    </Dialog>
  )
}

export default SendToDealerDialog
